import {useParams} from "react-router-dom";
import React from "react";
import ActivityHub from "./ActivityHub";

function GetUuidActivity () {
    let {uuid,user} = useParams()

    return (
        <ActivityHub uuid={uuid} user={user}/>
    )
}

export default GetUuidActivity;
